import { render, staticRenderFns } from "./FooterManager.vue?vue&type=template&id=0179caca&scoped=true&"
import script from "./FooterManager.vue?vue&type=script&lang=js&"
export * from "./FooterManager.vue?vue&type=script&lang=js&"
import style0 from "./FooterManager.vue?vue&type=style&index=0&id=0179caca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0179caca",
  null
  
)

export default component.exports